import { Box } from '@withjoy/joykit';
import React, { Children } from 'react';
import { BOX_SHADOW_16 } from '../constants/boxShadow';
import { cardDieCutToShapeConfig } from '../utils';
import { CardDieCut } from '../routes/CardCustomizer/CardCustomizer.types';

// Unfortunately we can't have an element clip its children but not its own box-shadow. So we need two elements.
export const Shadow: React.FC<{ shape: CardDieCut; shadow?: string }> = ({ children, shape, shadow }) => {
  return (
    <Box
      borderRadius={cardDieCutToShapeConfig(shape)?.borderRadius}
      transition="border-radius .3s"
      boxShadow={shadow || BOX_SHADOW_16}
    >
      {Children.only(children)}
    </Box>
  );
};
